export const PACKAGE_NAMES = ['IGNITE', 'ASCEND', 'MASTER', 'ELITE', 'PRO', 'TITAN', 'ULTIMATE'];

export const PACKAGE_PRICES = [20, 50, 100, 200, 300, 500, 1000];
export const RETOPUP_PRICES = [16, 40, 80, 160, 240, 400, 800];
export const CEILING_LIMITS = [48, 120, 240, 480, 720, 1200, 2400];

export const PACKAGE_COLORS = [
  '#ff6b35',
  '#00b4d8',
  '#9b5de5',
  '#ffd700',
  '#00f5d4',
  '#f72585',
  '#fb5607'
];

export const PACKAGE_GRADIENTS = [
  'linear-gradient(135deg, #ff6b3533, #ff6b350a)',
  'linear-gradient(135deg, #00b4d833, #00b4d80a)',
  'linear-gradient(135deg, #9b5de533, #9b5de50a)',
  'linear-gradient(135deg, #ffd70033, #ffd7000a)',
  'linear-gradient(135deg, #00f5d433, #00f5d40a)',
  'linear-gradient(135deg, #f7258533, #f725850a)',
  'linear-gradient(135deg, #fb580733, #fb58070a)'
];

export const ROYALTY_NAMES = {
  elite: 'Elite Royalty Pool',
  global: 'Global Royalty Pool'
};

export const PACKAGE_STATUS_COLORS = {
  active: '#34d399',
  ceilingHit: '#ef4444',
  nearCeiling: '#f59e0b',
  inactive: 'rgba(255,255,255,0.15)'
};

export const INCOME_COLORS = {
  board: '#00e5ff',
  direct: '#34d399',
  level: '#a855f7',
  autoLevel: '#ffd700',
  eliteRoyalty: '#ec4899',
  globalRoyalty: '#f97316',
  dividend: '#06b6d4'
};

export const ACTIVITY_TYPES = {
  1: { label: 'Package Activated', icon: '⚡' },
  2: { label: 'Board Income', icon: '💎' },
  3: { label: 'Direct Income', icon: '🔗' },
  6: { label: 'Royalty Claimed', icon: '👑' },
  7: { label: 'Level Income Claimed', icon: '📊' },
  8: { label: 'Auto Level Claimed', icon: '🔄' },
  9: { label: 'Re-Topup', icon: '🔋' },
  10: { label: 'Dividend Claimed', icon: '💰' }
};
